import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import ImageMicrotext from "../../../reusable_components/imageMicrotext";
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";
import PDFMicrotext from "../../../reusable_components/pdfMicrotext";
import MicrotextSizeAdjuster from "../../../reusable_components/microtextSizeAdjuster";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

export default function Microtext({ file, onDone, startLoader, stopLoader }) {
  const { state } = useLocation();
  const dispatch = useDispatch();

  const [previewImage, setPreviewImage] = useState([]);
  const [isPDF, setIsPDF] = useState(false);
  const [isImage, setIsImage] = useState(false);
  const [microtextSize, setMicrotextSize] = useState(1);
  const [finalCanvas, setFinalCanvas] = useState([]);

  // Parallel PDF rendering
  const renderPDF = async (file) => {
    if (startLoader) startLoader();
    setFinalCanvas([]);
    setPreviewImage([]);

    const pdfData = await file.arrayBuffer();
    const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
    const totalPages = pdf.numPages;
    const scale = 2;

    const renderedPages = await Promise.all(
      Array.from({ length: totalPages }, async (_, i) => {
        const page = await pdf.getPage(i + 1);
        const viewport = page.getViewport({ scale });

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        await page.render({ canvasContext: context, viewport }).promise;

        return canvas.toDataURL("image/png");
      })
    );

    setPreviewImage(renderedPages);
    if (stopLoader) stopLoader();
  };

  useEffect(() => {
    if (file) {
      // const file = state.data1.file;
      const fileName = file.name.toLowerCase();

      if (fileName.endsWith(".pdf")) {
        setIsPDF(true);
        renderPDF(file);
      } else if (/\.(jpe?g|png|bmp|gif|webp)$/i.test(fileName)) {
        setIsImage(true);
        setPreviewImage(URL.createObjectURL(file));
      } else {
        console.warn("Unsupported file type");
      }
    }
  }, [state]);

  const handleDone = async () => {
    if (startLoader) startLoader();

    if (isPDF && finalCanvas.length > 0) {
      const blobs = await Promise.all(
        finalCanvas.map(
          (canvas) =>
            new Promise((resolve) =>
              canvas.toBlob((blob) => resolve(blob || null), "image/png")
            )
        )
      );
      const validBlobs = blobs.filter(Boolean);
      onDone?.(validBlobs);
    } else if (isImage && finalCanvas) {
      finalCanvas.toBlob((blob) => {
        if (blob) onDone?.([blob]);
      }, "image/png");
    }

    if (stopLoader) stopLoader();
  };

  return (
    <div
      className="modal fade"
      id="create-microtext"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered model-custom-centered-microtext">
        <div className="modal-content microtext-modal-wrapper">
          <div className="microtext-modal-content">
            <img className="orange-wave" src="/images/orange-wave.svg" alt="" />
            <img className="blue-wave" src="/images/blue-wave.svg" alt="" />
            <button
              className="btn p-0 rounded-circle border-0 shadow-none cut-icon"
              data-bs-dismiss="modal"
            >
              <img src="/images/icons/icon-cross-red.svg" alt="cut" />
            </button>

            <div className="microtext-modal-header">
              <div className="w-100 uploaded-cards-wrapper-issuer-popup">
                <div className="upload-cards">
                  <div className="bottom-content-wrapper">
                    <div className="bottom-content">
                      {isPDF ? (
                        <div className="pdf-scroll-container">
                          {previewImage.map((img, index) => (
                            <PDFMicrotext
                              key={index}
                              pdfSrc={img}
                              outerRows={4}
                              outerCols={4}
                              outerCellColor="rgba(0, 0, 0, 0)"
                              innerCellFontSize={microtextSize}
                              onReady={(canvas) => {
                                setFinalCanvas((prev) => {
                                  const updated = [...(prev || [])];
                                  updated[index] = canvas;
                                  return updated;
                                });
                              }}
                            />
                          ))}
                        </div>
                      ) : isImage ? (
                        <ImageMicrotext
                          src={previewImage}
                          outerRows={4}
                          outerCols={4}
                          outerCellColor="rgba(0, 0, 0, 0.2)"
                          innerCellFontSize={microtextSize}
                          onReady={setFinalCanvas}
                        />
                      ) : (
                        <div>No image or PDF to display</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="microtext-btn">
              <MicrotextSizeAdjuster
                size={microtextSize}
                setSize={setMicrotextSize}
              />
              <button
                className="text-uppercase bdrs10 fw600 fz10 btn btn-solid btn-solid--dark microtext-btn-popop"
                data-bs-toggle="modal"
                data-bs-target="#create-microtext"
                onClick={handleDone}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
